// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__OtkJz","title":"styles_title__jbBCj","subtitle":"styles_subtitle__ITUmK"};